import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoices = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.2074 16.9967L15.3824 17.4113C15.1487 17.5287 14.8733 17.5296 14.6389 17.4137L13.3285 16.7657L12.0444 17.4107C11.8099 17.5285 11.5338 17.529 11.2989 17.4121L9.99992 16.7654L8.70095 17.4121C8.4661 17.529 8.18991 17.5285 7.95549 17.4107L6.6714 16.7657L5.361 17.4137C5.12651 17.5296 4.85118 17.5287 4.61744 17.4113L3.79244 16.9967C3.51093 16.8552 3.33326 16.5671 3.33325 16.2521V3.74793C3.33326 3.43289 3.51092 3.14478 3.79242 3.00333L4.61742 2.58873C4.85116 2.47127 5.12649 2.47038 5.36099 2.58634L6.67139 3.23433L7.95547 2.58927C8.18989 2.47151 8.46609 2.47101 8.70093 2.58792L9.99992 3.23459L11.2989 2.58792C11.5337 2.47101 11.8099 2.47151 12.0444 2.58927L13.3284 3.23433L14.6388 2.58634C14.8733 2.47038 15.1487 2.47127 15.3824 2.58873L16.2074 3.00333C16.4889 3.14478 16.6666 3.43289 16.6666 3.74793V16.2521C16.6666 16.5671 16.4889 16.8552 16.2074 16.9967Z",
			fill: "#748094"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3334 7.50016H6.66675",
			stroke: "white",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3334 10.0002H6.66675",
			stroke: "white",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8334 12.5002H6.66675",
			stroke: "white",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgInvoices;
